import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class ChargeTypeReferenceService extends BaseReferenceService {
  constructor() {
    super('ChargeTypeReference');
  }
}
